<ng-container *ngIf="routerLink; else externalLink">
  <a
    class="more-btn rise-on-hover"
    [class.more-btn-small]="small"
    [routerLink]="routerLink"
  >
    <button>
      {{ title }}
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </a>
</ng-container>
<ng-template #externalLink>
  <a
     class="more-btn rise-on-hover"
     [class.more-btn-small]="small"
     [href]="link"
  >
    <button>
      {{ title }}
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </a>
</ng-template>
